import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["submit-button relative btn btn-purple-500", { 'pr-[50px] is-loading': $props.loading, 'opacity-50 cursor-not-allowed': $props.disabled }]),
    disabled: $props.disabled || $props.loading,
    type: "submit"
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 10 /* CLASS, PROPS */, _hoisted_1))
}